// extracted by mini-css-extract-plugin
export default {"form":"Formbody_form__0c40+"};